import { Injectable } from "@angular/core";
import { BaseHandler } from "@app/core/shared/data/network/base-handler";
import { ApiUrls } from "@app/core/shared/data/network/api-urls";
import { Observable, map } from "rxjs";
import { TokenAuthorization } from "@app/core/shared/data/network/token-authorization";
import {
  HandlerBuilder,
  HttpMethod,
} from "@app/core/shared/data/network/base-handler.parameters";

@Injectable({
  providedIn: "root",
})
export class getPublicVideoLinkWS {
  constructor(private baseHandler: BaseHandler) {}

  execute(
    matchId: string,
    type: "short" | "extended",
    token: string
  ): Observable<string> {
    const video_type =
      type === "short"
        ? ApiUrls.SHARE_SHORT_VIDEO
        : ApiUrls.SHARE_EXTENDED_VIDEO;
    const parameters = new HandlerBuilder()
      .setUrl(ApiUrls.GET_PUBLIC_VIDEO_ENDPOINT(matchId, video_type))
      .setMethod(HttpMethod.post)
      .setAuthorization(new TokenAuthorization(token))
      .build();
    return this.baseHandler
      .execute(parameters)
      .pipe(map((response) => response.url));
  }
}
